import { AvailabilitiesResponse } from "@/types/responses";

/**
 * Builds the list of { liheId, codePackage, prestId } used to drive WIYP calls.
 *
 * For HS, `availablePackages[].prestId` can be an accommodation id (e.g. a fusion
 * product's prestId) rather than `${liheId}HS`. Always derive the HS package id
 * from `fusionId ?? liheId` so each fused lihe gets its own WIYP call.
 */
export const getAvailablePackagesWiyp = (availResponse: AvailabilitiesResponse) => {
    const availablePackageCodeWiyp: { liheId: string, codePackage: string, prestId: string, maxPromo: number, skipass: number | undefined, origins?: string[] }[] = []

    const pushEntry = (
        liheId: string,
        codePackage: string,
        prestId: string,
        skipass: number | undefined,
        origins?: string[]
    ) => {
        availablePackageCodeWiyp.push({
            liheId,
            codePackage,
            prestId,
            maxPromo: 0,
            skipass,
            origins,
        })
    }

    availResponse.availablePackages!.forEach(availablePackage => {
        const effectiveLiheId = availablePackage.fusionId ?? availablePackage.liheId!
        const codePackage = availablePackage.codePackage!
        const prestId =
            codePackage === "HS"
                ? `${effectiveLiheId}HS`
                : (availablePackage.prestId! as string)
        pushEntry(effectiveLiheId, codePackage, prestId, availablePackage.skipass ?? undefined, availablePackage.origins)
    });

    availResponse.prestations!.forEach(prestation => {
        const effectiveLiheId = prestation.fusionId ?? prestation.liheId!
        const codePackage = prestation.codePackage!
        const prestId =
            codePackage === "HS"
                ? `${effectiveLiheId}HS`
                : prestation.prestId!
        pushEntry(effectiveLiheId, codePackage, prestId, prestation.skipass ?? undefined, prestation.origins)
    });

    // Ensure only unique codePackage/prestId combinations
    const uniqueMap = new Map();
    for (const entry of availablePackageCodeWiyp) {
        const key = `${entry.codePackage}-${entry.prestId}`;
        if (!uniqueMap.has(key)) {
            uniqueMap.set(key, entry);
        }
    }
    return Array.from(uniqueMap.values())
}
